module.exports = __webpack_public_path__ + "img/46830015 1.bec8c2e8.png";